<div class="h-96 relative lg:py-96">
  <img alt="" class="object-cover " fill="" ngSrc="assets/images/univers-banner.webp">
</div>
<div class="bg-bleuCaliceo-300">
  <section class="layout py-24">
    <h1
      class="font-caliceo text-6xl leading-normal md:!leading-loose lg:text-8xl text-white">{{ 'theCaliceoUniverse'  | translate }}</h1>
    <h2 class="font-bold mb-4 text-4xl leading-tight text-white">{{ 'universeTitle'  | translate }}</h2>
    <p class="font-semibold text-white text-xl pb-8">{{ 'universeDescription'  | translate }}</p>

    <div class="md:grid grid-cols-2 gap-10 text-justify">
      <p [innerHtml]="'universeInfo1' | translate" class="text-white"></p>
      <p [innerHtml]="'universeInfo2' | translate" class="text-white"></p>
    </div>
  </section>
</div>

@for (universe of universeService.universes(); track universe.id) {
  <div [ngClass]="{ 'bg-bleuCaliceo-300 bg-opacity-10': $odd }">
    <div class="layout py-24">
      <h1 class="text-4xl font-semibold text-gray-600 uppercase">{{ universe.name }}</h1>
      @for (activity of universe.getActivities(siteService.center()?.erpId); track activity.name) {
        @if (universeService.activity(activity, siteService.center()?.id); as centerActivity) {
          <div [id]="centerActivity.name" class="md:grid grid-cols-2 md:gap-20 py-6 md:py-12">
            <div [ngClass]="{ 'order-last': $even }" class="py-5 flex justify-center flex-col">
              <h3
                class="font-bold mb-9 text-2xl leading-tight text-bleuCaliceo-300 uppercase"> {{ centerActivity.name }}</h3>
              <app-inner-html
                [html]="universeService.translate(siteService.center()?.id, universe.id, activity.id, 'longDescription')"></app-inner-html>
              @if (siteService.center()) {
                <a appHoverGradient routerLink="/offers"
                   [queryParams]="{universe: universe.name, activity: centerActivity.name}" queryParamsHandling="merge"
                   class="flex items-center gap-3 mt-6 justify-center w-64 py-3">
                  {{ 'offers' | translate }}
                  <img class="h-5" alt="" ngSrc="assets/icons/white/newtab.svg" width="24" height="24">
                </a>
              }
            </div>
            <div class="min-h-72 h-full w-full relative self-center">
              @if (centerActivity.images[0]; as image) {
                <img class="object-cover rounded-lg"
                     fill=""
                     sizes="(max-width: 768) 100vw, 50vw"
                     [alt]="image.alt"
                     [ngSrc]="image.media">
              } @else {
                <img class="object-cover rounded-lg"
                     fill=""
                     sizes="(max-width: 768) 100vw, 50vw"
                     [alt]="centerActivity.name"
                     ngSrc="assets/images/placeholder.webp">
              }
            </div>
          </div>
        }
      }
    </div>
  </div>
}
